// quizConstants.js
export const OPTION_KEYS    = ['optionA', 'optionB', 'optionC', 'optionD'];
export const OPTION_LETTERS = ['A', 'B', 'C', 'D'];
